import { Cart } from '@medusajs/medusa';
import { formatMedusaPrice } from './formatMedusaPrice';

export const getCartTotals = (cart: Omit<Cart, 'refundable_amount' | 'refunded_total'>, mealTypeId: string) => {
  const lineItemsTotals = cart.items.reduce((acc, item) => acc + item.unit_price * item.quantity, 0);
  const shippingTotals = (cart?.shipping_total || 0) + (cart?.shipping_tax_total || 0);

  let total = lineItemsTotals + shippingTotals;

  return formatMedusaPrice(total);
};
